module.exports = __webpack_public_path__ + "img/SHFirmwareUpdate.eea13f35.svg";